import React from 'react';
function Nav(){
    return(
<nav className="navbar navbar-light bg-light ">
<span className="navbar-brand mb-0 h1">Math-Calculator</span>
</nav>);
}


export default Nav;